module.exports = __webpack_public_path__ + "img/8.663ad335.jpg";